<template>
    <el-dialog class="peiso-modal transaction-selector"
    :visible.sync="isOpen"
    :modal-append-to-body="false"
    :close-on-click-modal='true'
    :close-on-press-escape="true"
    width="750px"
    :before-close="handleClose"
    center>

        <div>
            <div class="header-container">
                <span v-if="!isDaily">
                     Choose a transaction
                </span>
                <span v-else>
                    Choose a weekly report transaction
                </span>
            </div>

            <div v-if="!isDaily" class="body-transaction d-flex justify-content-center gap-16 m-top-1-5rem">
                <div class="feature-container w-100 d-flex flex-column align-items-center gap-16 justify-content-center cursor-pointer" @click="goToEod">
                    <img src="@/assets/eod.svg" height="50px" alt="">
                    <span>End of Day Report</span>
                </div>

                <div class="feature-container w-100 d-flex flex-column align-items-center gap-16 justify-content-center cursor-pointer" @click="goToCashupBanking">
                    <img src="@/assets/cashup.svg" height="50px" alt="">
                    <span>Cash up and Banking</span>
                </div>

                <div v-if="isManualJournalActivated" class="feature-container w-100 d-flex flex-column align-items-center gap-16 justify-content-center cursor-pointer" @click="goToJournal">
                    <img src="@/assets/file.svg" height="50px" alt="">
                    <span>Manual Journal</span>
                </div>

                <a v-if="isEosActivated && env.NAME != 'lucas'"  class="feature-container w-100 d-flex flex-column align-items-center gap-16 justify-content-center cursor-pointer" :href="eosLink()" target="_blank">
                    <img src="@/assets/eos.svg" height="50px" alt="">
                    <span>End of shift</span>
                </a>
            </div>

            <div v-if="isDaily" class="body-transaction d-flex justify-content-center gap-16 m-top-1-5rem">
                <div class="feature-container w-100 d-flex flex-column align-items-center gap-16 justify-content-center cursor-pointer" @click="showWeeklyReport">
                    <img src="@/assets/eod.svg" height="50px" alt="">
                    <span>End of week report</span>
                </div>

                <div class="feature-container w-100 d-flex flex-column align-items-center gap-16 justify-content-center cursor-pointer" @click="showWeeklyCashup">
                    <img src="@/assets/cashup.svg" height="50px" alt="">
                    <span>Cash up weekly report</span>
                </div>

            </div>
        </div>

    </el-dialog>
</template>

<style lang='scss'>
@import '../../../static/scss/colors.scss';
@import '../../../static/scss/fonts/fonts.scss';
    .transaction-selector {

        .feature-container {
            @include montserrat-font(15px, 150%, 600, $white) {
                letter-spacing: 0.2px;
                gap: 1rem;
                border-radius: 5px;
                border: 1px solid $gray6;
                position: relative;
                height: 150px;
                transition: 0.3s;
            }

            text-decoration: none !important;

            &:hover {
                background-color: var(--primary-color);
            }

        }
    }
</style>

<script>
    import { env } from '../../env'
    export default {
        data() {
            return {
                isOpen: false,
                env: env,
            }
        },

        props: {
            open: {
                default: false,
            },
            isManualJournalActivated: {
              default: false,
            },
            isEosActivated: {
                default: false,
            },
            isDaily: {
                default: 0
            },
            currentSelectedDate: {
                default: null,
            }
        },
        watch: {
            open(val) {
                this.isOpen = val
            }
        },
        methods: {
            eosLink() {
                const venueId = sessionStorage.getItem('subVenueId')
                const date = this.currentSelectedDate
                return `${this.env.BASE_URL}/forms/eos/venues/${venueId}/select?date=${date}`
            },
            handleClose() {
                this.isOpen = false
                this.$emit('close-modal')
            },

            goToCashupBanking() {
                this.handleClose()
                this.$emit('open-cashup')
            },

            goToEod() {
                this.handleClose()
                this.$emit('open-eod')
            },
            
            showWeeklyReport() {
                this.handleClose()
                this.$emit('show-weekly-report')
            },
            
            showWeeklyCashup() {
                this.handleClose()
                this.$emit('show-weekly-cashup')
            },

            goToJournal() {
                this.handleClose()
                this.$emit('open-journal')
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/modal/transactionSelection.vue